/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  SvgIcon
} from "../"

// Alert banners communicate a state that affects the entire system, not just a
// feature or page. It persists over a session and appears without the user initiating the action.
export const Alert = (props) => (
  <div className={`slds-notify slds-notify_alert slds-theme_alert-texture slds-theme_${props.type}`} role="alert">
    <span className="slds-assistive-text">{props.type}</span>
    {props.noTypeIcon
      ? <span></span>
      : <span className="slds-icon_container slds-m-right_x-small" title="Description of icon when needed">
          <SvgIcon
            variant="utility"
            symbol={props.type === "error" ? "ban" : props.type}
            size="x-small"
            colour="inverse"
          />
        </span>
    }
    <h2>{props.message} <a href={props.actionLink}>{props.actionText}</a></h2>
    <Button
      type="reset"
      className="slds-button_icon slds-notify__close"
      title="Close">
      <SvgIcon
        variant="utility"
        symbol="close"
        size="small"
        colour="inverse"
      />
      <span className="slds-assistive-text">Close</span>
    </Button>
  </div>
)

Alert.defaultProps = {
  type: "user"
}

Alert.propTypes = {
  message: PropTypes.string.isRequired,
  actionText: PropTypes.string,
  actionLink: PropTypes.string,
  type: PropTypes.oneOf(["user", "offline", "warning", "error"]),
  noTypeIcon: PropTypes.bool,
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/alert/index.js